var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-82ab1bb3-17e8-4cae-975e-289b9a79a130",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2033348a-5067-4324-a86e-e52d1b8870c0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2033348a-5067-4324-a86e-e52d1b8870c0",
    d: "M21.21,14.53h-7.48c-.98,0-1.78.8-1.78,1.78v1.88l-1.42-3.58c-.04-.09,0-.2.1-.23l7.14-2.83c.08-.03.2.02.23.1l.74,1.86c.15.39.59.57.97.42.38-.15.57-.59.42-.97l-.74-1.86c-.17-.42-.48-.75-.9-.92-.41-.18-.87-.18-1.29-.02l-7.14,2.83c-.42.17-.75.48-.92.9-.18.41-.19.87-.02,1.29l1.5,3.79c.23.57.74.94,1.31,1.02v.21c0,.98.8,1.78,1.78,1.78h7.48c.98,0,1.78-.8,1.78-1.78v-3.87c0-.98-.8-1.78-1.78-1.78ZM13.72,16.03h7.48c.16,0,.28.13.28.28v.36h-8.05v-.36c0-.16.13-.28.28-.28ZM21.21,20.47h-7.48c-.16,0-.28-.13-.28-.28v-2.02h8.05v2.02c0,.16-.13.28-.28.28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2033348a-5067-4324-a86e-e52d1b8870c0",
    x: 14.24,
    y: 18.9,
    width: 0.72,
    height: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.26a1e9ea8aefcd577f79582c5071a184.svg";
export { ForwardRef as ReactComponent };